import styled from '@emotion/styled';
import { borderColor } from '../TableRowContainer/TableRowContainer.styled';
import { StyledProps } from './TableHeadContainer.types';

export default styled.thead<StyledProps>`
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  list-style-type: none;
  border-collapse: collapse;
  border: 1px ${borderColor};
  border-bottom-width: 0px;
  border-style: solid;
  background-color: var(--color-b0);
  font-size: 16px;

  tr {
    border-bottom-width: 0px;
  }

  @media (max-width: 1460px) {
    font-size: 14px;
  }

  @media (max-width: 1200px) {
    font-size: 13px;
  }
`;
